import { Link } from "react-router-dom";
import { TAGLINES, PURE_SOULS_URL } from "@/lib/site";
import GetListedDialog from "@/components/site/GetListedDialog";

const groups = [
  {
    title: "Learn",
    links: [
      { to: "/what-is-water-cremation", label: "What Is Water Cremation" },
      { to: "/benefits", label: "Benefits Of Water Cremation" },
      { to: "/the-process", label: "The Process" },
      { to: "/faq", label: "Frequently Asked Questions" },
    ],
  },
  {
    title: "Explore",
    links: [
      { to: "/articles", label: "Learning Centre" },
      { to: "/providers", label: "Find A Provider" },
    ],
  },
];

export default function Footer() {
  const tagline = TAGLINES[new Date().getDate() % TAGLINES.length];

  return (
    <footer
      className="bg-sand-100 border-t border-sand-300/60 mt-24"
      data-testid="site-footer"
    >
      <div className="container-editorial py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="overline mb-4">Pet Water Cremation Australia</div>
            <h3 className="font-serif text-3xl sm:text-4xl text-forest-900 leading-tight tracking-tight mb-5">
              {tagline}
            </h3>
            <p className="text-forest-700 leading-relaxed max-w-md">
              Pet Water Cremation Australia was created to help educate Australian
              families about pet water cremation, aqua cremation, and sustainable
              alternatives for pet aftercare. Our mission is to provide calm,
              trustworthy, and informative resources to help families better
              understand this emerging form of pet memorial care.
            </p>
            <div className="mt-6">
              <GetListedDialog
                triggerLabel="Operate a water cremation service? Get listed →"
                triggerClassName="link-underline text-sm"
                triggerTestId="footer-get-listed"
              />
            </div>
          </div>

          <div className="lg:col-span-4 grid grid-cols-2 gap-8">
            {groups.map((g) => (
              <div key={g.title}>
                <div className="overline mb-4">{g.title}</div>
                <ul className="space-y-3">
                  {g.links.map((l) => (
                    <li key={l.to}>
                      <Link
                        to={l.to}
                        className="text-forest-800 hover:text-forest-900 text-[15px] tracking-wide transition-colors"
                        data-testid={`footer-link-${l.to.replace(/\//g, "")}`}
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <div className="overline mb-4">Featured Provider</div>
            <p className="font-serif text-2xl text-forest-900 leading-tight mb-2">
              Pure Souls Pet Aqua Cremation
            </p>
            <p className="text-forest-700 text-sm leading-relaxed mb-4">
              Townsville, Queensland. Premium pet water cremation services.
            </p>
            <a
              href={PURE_SOULS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="link-underline text-sm"
              data-testid="footer-pure-souls-link"
            >
              puresouls.com.au →
            </a>
          </div>
        </div>

        <div className="border-t border-sand-300 mt-16 pt-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-sm text-forest-700">
            © {new Date().getFullYear()} Pet Water Cremation Australia · An
            educational resource
          </p>
          <p className="text-xs text-forest-700 uppercase tracking-[0.22em]">
            Compassion · Science · Sustainability
          </p>
        </div>
      </div>
    </footer>
  );
}
